/**
 * @file Web Galleries main view.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';

import Footer from '../../../components/global/Footer';

const propTypes = {
  route: PropTypes.object,
};

const WebGalleriesMainView = ({ route }) => {
  return (
    <div className="wrapper-main">
      {renderRoutes(route.routes)}
      <Footer />
    </div>
  );
};

WebGalleriesMainView.propTypes = propTypes;

export default WebGalleriesMainView;
